// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"0eda7b768f1ffd03e277","691":"29ae5ebfa43ce9c98ed1"}[chunkId] + ".js";
};